/**
 * A sentinel for "these values disagree", modelled on the editor's `@fullscreen/scenegraph/mixed`. A
 * field holds it instead of one of the values, so a formatter decides how to render it.
 */
export const MIXED = Symbol('mixed');

export type Mixed = typeof MIXED;

export function isMixed<T>(value: T | Mixed): value is Mixed {
  return value === MIXED;
}

export function getValue<T, F>(value: T | Mixed | undefined, fallback: F): T | F {
  return value === undefined || isMixed(value) ? fallback : value;
}
